import {} from './styles'

const PostDetails = () => {
    console.log('POST DETAILS')
  return (
    <div>
        POST DETAILS
    </div>
  )
}

export default PostDetails